import { extractNode, extractNodeList } from '../graph-row'
import { compareByNameThenId } from '../sort'
import type {
  CypherReadResult,
  PlantEquipment,
  PlantPartRef,
  PlantVendorDetail,
  PlantVendorPart,
  PlantVendorRef,
  PlantVendorRole
} from '../types'

function vendorRole(value: unknown): PlantVendorRole | null {
  return value === 'manufacturer' || value === 'supplier' ? value : null
}

function extractParts(value: unknown): PlantVendorPart[] {
  if (!Array.isArray(value)) return []
  const rows = new Map<string, PlantVendorPart>()
  for (const item of value) {
    if (!item || typeof item !== 'object') continue
    const row = item as Record<string, unknown>
    const part = extractNode<PlantPartRef>(row['part'])
    const role = vendorRole(row['role'])
    if (part && role) rows.set(`${part.id}:${role}`, { part, role })
  }
  return [...rows.values()].sort(
    (a, b) => compareByNameThenId(a.part, b.part) || a.role.localeCompare(b.role)
  )
}

export function mapPlantVendorDetail(raw: CypherReadResult, vendorId: string): PlantVendorDetail {
  const row = raw.results[0] ?? {}
  const vendor =
    extractNode<PlantVendorRef>(row['v']) ??
    ({ id: vendorId, _id: vendorId, name: 'Unknown vendor' } satisfies PlantVendorRef)

  return {
    vendor,
    parts: extractParts(row['parts']),
    equipment: extractNodeList<PlantEquipment>(row['equipment']).sort(compareByNameThenId),
    isStray: row['isStray'] === true
  }
}
